import { Box, Button, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../Hooks/useHandleApiResponse';

export default function GlobalDialogueContent({
  content,
  sx = { minWidth: 300 },
  cancel,
  setOpen,
  dispatchParams,
  dispatchFn,
  onSuccess,
  onSuccessDispatchFn,
  successDispatchParams,
  onFailed,
  loading,
  contentStyle = { fontWeight: 500 },
  buttonLabel = 'submit',
  buttonLoadingLabel = 'Loading',
  buttonSx = {},
  buttonVariant = 'outlined',
}) {
  const dispatch = useDispatch();
  const handleResponseApi = useHandleApiResponse();

  const handleDelete = () => {
    dispatch(dispatchFn(dispatchParams)).then((res) => {
      handleResponseApi(res, {
        onSuccess: () => {
          if (onSuccess) onSuccess();
          if (onSuccessDispatchFn) dispatch(onSuccessDispatchFn(successDispatchParams));
          setOpen(false);
        },
        onFailed,
      });
    });
  };

  return (
    <Box display={'flex'} flexDirection={'column'} gap={3} sx={sx}>
      <Typography sx={contentStyle}>{content}</Typography>
      <Box
        display={'flex'}
        sx={{
          alignSelf: 'flex-end',
          gap: 1,
        }}
      >
        {cancel && (
          <Button variant="outlined" onClick={() => setOpen(false)}>
            cancel
          </Button>
        )}
        <Button variant={buttonVariant} sx={buttonSx} onClick={() => handleDelete()} disabled={loading ?? false}>
          {loading ? (loading ? `${buttonLoadingLabel}...` : buttonLabel) : buttonLabel}
        </Button>
      </Box>
    </Box>
  );
}
